import { Get, Post } from "./common";

export default class TrustapUserService {
  static createGuestAccount = async (token: string, data: any) =>
    await Post({
      path: "trustap-users/guest",
      token,
      body: data,
    });

  static getMyTrustapAccount = async (token: string) =>
    await Get({ path: "trustap-users", token });

  static getConnectionHealth = async (token: string) =>
    await Get({ path: "trustap-users/connection-health", token });

  static setStateToken = async (token: string, data: any) =>
    await Post({ path: "trustap-users/state-token", token, body: data });

  static verifyAndFinalize = async (token: string, data: any) =>
    await Post({
      path: "trustap-users/verify-and-finalize",
      token,
      body: data,
    });

  static unlink = async (token: string) =>
    await Post({ path: "trustap-users/unlink", token, body: {} });
}
